<template>
  <div class="auth-layout row align-content--center">
    <div class="flex xs12 pa-3 flex-center">
      <router-link class="py-5 flex-center" to="/">
        <vuestic-logo height="32"/>
      </router-link>
    </div>

    <div class="flex xs12 pa-3">
      <div class="d-flex justify--center">
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>

        <va-tabs v-model="tabIndex" center>
          <template #tabs>
          </template>
        </va-tabs>

        <div class="pa-3">
          <router-view />
        </div>
 
      </div>
    </div>
  </div>
</template>

<script>
import VuesticLogo from "@/components/thcom-logo.vue";

export default {
  name: "AuthLayout",
  components: { VuesticLogo },
  data() {
    return {
      selectedTabIndex: 0
    };
  },
  computed: {
    tabIndex: {
      set(tabName) {
        this.$router.push({ name: tabName });
      },
      get() {
        return this.$route.name;
      }
    }
  }
};
</script>

<style lang="scss">
.auth-layout {
  min-height: 100vh;
  background-image: linear-gradient(to right, var(--va-background), var(--va-white));

  &__card {
    width: 100%;
    max-width: 600px;
  }
}
</style>
